// extracted by mini-css-extract-plugin
module.exports =  {"syncContentLoader":"syncContentLoader_bjrBJUbF","shimmer":"shimmer__823Z6w7"};